import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { LogoAffiliate } from '@motorway/motorway-storybook-cra';

import T from 'Utilities/texts';

import { Content } from 'LegacySBCRA/Content/Content';

import styles from './AffiliateHeader.scss';

const AffiliateHeader = ({
  affiliate,
}) => (
  <Content
    className={styles.component}
    wrapper={{ className: styles.wrapper }}
  >
    <div>{T.translate('components.affiliateHeader.title')}</div>
    <LogoAffiliate
      affiliate={affiliate}
      className={cx(styles.affiliateLogo, styles[affiliate])}
    />
  </Content>
);

AffiliateHeader.propTypes = {
  affiliate: PropTypes.string.isRequired,
};

export default AffiliateHeader;
